module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), (_vm.isManager()) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, _vm._l((_vm.backups), function(b, index) {
    return (_vm.canAccess(b.access ? b.access : '')) ? _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": b.name,
        "name": b.menu
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 22
      }
    }, _vm._l((b.buttons), function(btn, ind) {
      return _c('span', {
        key: ind
      }, [((btn.access ? _vm.canAccess(btn.access) : true)) ? _c('el-col', {
        attrs: {
          "sm": 24,
          "md": 12,
          "lg": 8
        }
      }, [_c('download-button', {
        attrs: {
          "text": btn.label,
          "cls-style": "width: 100%;margin-top: 1em; margin-bottom: 1em;",
          "url": btn.export,
          "type": (btn.type ? btn.type : 'info'),
          "icon": 'fa fa-' + (btn.icon ? btn.icon : 'download'),
          "rounded": (btn.rounded ? btn.rounded : true),
          "disabled": (btn.disabled ? btn.disabled : false)
        }
      })], 1) : _vm._e()], 1)
    }), 0)], 1) : _vm._e()
  }), 1) : _c('el-alert', {
    attrs: {
      "title": "Insufficient Access Rights",
      "description": "You don't have access rights to backup data.",
      "show-icon": "",
      "closable": false
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-floppy-disk"
  }), _vm._v(" Backup")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fd95389"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Backup.vue
// module id = 1520
// module chunks = 0